<div
  [style.width.px]="size"
  [style.height.px]="size"
  class="dummy-animated rounded-full overflow-hidden"
>
  <img *ngIf="src" [src]="src" class="object-cover w-full h-full" />
</div>
